import { Box, Button, Typography } from '@mui/material';

interface IProps {
  refetch: () => void;
}

export const NoDataContenct = ({ refetch }: IProps) => (
  <Box
    sx={{
      minHeight: '50vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
    }}
  >
    <Typography variant='h6'>
      Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.
    </Typography>
    <Button variant='contained' onClick={() => refetch()}>
      Erneut versuchen
    </Button>
  </Box>
);
